import React, { useEffect, useCallback, useMemo } from "react";
import {
    Switch,
    Route
} from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';

import HeaderTop from "./Header/HeaderTop";
import HeaderBottom from "./Header/HeaderBottom";

import Home from "./Home/Home";
import HomeSlider from "./Home/HomeSlider";
import About from "./Home/About";
import Contact from "./Home/Contact";
import Slider from "./Home/Slider";
import NotFound from "./Home/NotFound";
import NoPermissions from "./Home/NoPermissions";
import Tracks from "./Home/Tracks/Tracks";
import Books from "./Home/Tracks/Books";
import BookLessons from "./Home/Tracks/BookLessons";
import Lessons from "./Home/Tracks/Lessons";
import Files from "./Home/Tracks/Files";
import LessonView from "./Home/Tracks/LessonView/LessonView";
import PDFView from "./Home/Tracks/LessonView/PDFView";
import FilePDFView from "./Home/Tracks/LessonView/FilePDFView";
import Exams from "./Home/Tracks/Exams";
import Quizzes from "./Home/Tracks/Quizzes";
import ExamView from "./Home/Tracks/ExamView/";
import SelfDevelopmentView from "./Home/Tracks/SelfDevelopmentView/";
import GameView from "./Home/Tracks/GameView/";
import CompetitionView from "./Home/Tracks/CompetitionView/";

import Register from "./Home/Register";
import SingleRegister from "./Home/Registration/SingleRegister/";
import ContactSupportConfirmation from "./Home/Registration/SchoolRegister/ContactSupportConfirmation.js";
import Registration from "./Home/Registration/";
import Login from "./Home/Login";
import PayBill from "./Home/PayBill";
import Search from "./Home/Search/";
import AfterPurchase from "./Home/AfterPurchase";
import PayproAfterPurchase from "./Home/PayproAfterPurchase";
import ForgetPassword from "./Home/ForgetPassword";
import ResetPassword from "./Home/ResetPassword";
import Games from "./Home/Tracks/Games";
import CompetitionStage from "./Home/Tracks/CompetitionStage/";
import CompetitionInfo from "./Home/Tracks/CompetitionStage/CompetitionInfo.js";
import Prices from "./Home/Prices";
import UserGuide from "./Home/UserGuide/";
import Article from "./Home/UserGuide/Article.js";
import Chatbot from "./Home/Chatbot";

import Logout from "./Home/User/Logout";
import Profile from "./Home/User/Profile/index";
import ProfileEdit from "./Home/User/ProfileEdit";
import ActivePage from "./Home/User/ActivePage";
import RecognizedBrowser from "./Home/User/RecognizedBrowser";
import ProfileChangePassword from "./Home/User/ChangePassword";
import ChangeProfilePicture from "./Home/User/ProfilePicture";
import UserFavoriteLesson from "./Home/User/UserFavoriteLesson";
import UserFavoriteFile from "./Home/User/UserFavoriteFile";
import UserHistoryLessons from "./Home/User/UserHistoryLessons";
import UserHistoryFiles from "./Home/User/UserHistoryFiles";
import UserBills from "./Home/User/UserBills";
import UserControl from "./Home/User/UserControl";
import UserRenwal from "./Home/User/Renwal";
import UserSubscription from "./Home/User/Subscription";
import SubUsers from "./Home/User/SubUsers";
import UserMarks from "./Home/User/UserMarks/index";

import Indices from "./Admin/Indices/Indices";
import ControlPanel from "./Admin/ControlPanel";
import LessonEdit from "./Admin/Lessons/LessonEdit";
import QuizzesEdit from "./Admin/Quizzes/QuizzesEdit";
import ExamsEdit from "./Admin/Exams/ExamsEdit";
import BookLessonEdit from "./Admin/Books/BookLessonEdit";
import LessonsList from "./Admin/Lessons/Lessons";
import FilesList from "./Admin/Files/Files";
import BooksList from "./Admin/Books/Books";
import ExamsList from "./Admin/Exams/Exams";
import SelfDevelopmentList from "./Admin/SelfDevelopment/";
import SelfDevelopmentEdit from "./Admin/SelfDevelopment/SelfDevelopmentEdit";

import BookLessonsList from "./Admin/Books/BookLessons";
import QuizzesList from "./Admin/Quizzes/Quizzes";
import FunList from "./Admin/Games";
import GamesEdit from "./Admin/Games/GamesEdit";

import Loading from "./Loading";
import MissionView from './Home/Tracks/MissionView';
import history from '../history';
import { checkLogin } from './actions/';
import api from "../api/api";
import { realtimeService } from "../../realtime/RealtimeService";
import { studentLiveObserver } from "../../realtime/services/StudentLiveObserver";
import GlobalRealtimeAlerts from "./GlobalRealtimeAlerts";

const UsersList = React.lazy(() => import("./Admin/Users/"));
const SchoolsList = React.lazy(() => import("./Admin/Schools/"));
const SchoolsRegistrationList = React.lazy(() => import("./Admin/RegistrationSchools/"));
const MailBoxList = React.lazy(() => import("./Admin/MailBox/"));
const SearchResultList = React.lazy(() => import("./Admin/SearchResult/"));
const SlidersList = React.lazy(() => import("./Admin/Sliders/"));
const EmailContentList = React.lazy(() => import("./Admin/EmailContent/"));
const SchoolRank = React.lazy(() => import("./Admin/SchoolRank/"));
const OnlineUser = React.lazy(() => import("./Admin/OnlineUser/"));
const StudentRank = React.lazy(() => import("./Admin/StudentRank/"));
const UserRank = React.lazy(() => import("./Admin/UserRank/"));
const FileManagerList = React.lazy(() => import("./Admin/FileManager/"));
const BillsList = React.lazy(() => import("./Admin/Bills/"));
const SendEmail = React.lazy(() => import("./Admin/SendEmail/"));
const Templates = React.lazy(() => import("./Admin/Templates/"));
const GameTemplates = React.lazy(() => import("./Admin/GameTemplates/"));
const ErrorReport = React.lazy(() => import("./Admin/ErrorReport/"));
const WhatsApp = React.lazy(() => import("./Admin/WhatsApp/WhatsApp"));
const SMS = React.lazy(() => import("./Admin/SMS/SMS"));
const UsersStatistics = React.lazy(() => import("./Admin/Statistics/Users/"));
const LessonsStatistics = React.lazy(() => import("./Admin/Statistics/Lessons/"));
const CompetitionStatistics = React.lazy(() => import("./Admin/Statistics/Competition/"));
const DeepSeekAdmin = React.lazy(() => import("./Admin/DeepSeek"));
const QuestionsAdminView = React.lazy(() => import("./Admin/QuestionView/QuestionView"));
const CacheManagerAdmin = React.lazy(() => import("./Admin/CacheManager"));
const ServerHealthAdmin = React.lazy(() => import("./Admin/ServerHealth"));

const ClassRoomsList = React.lazy(() => import("./School/ClassRooms/"));
const TeachersList = React.lazy(() => import("./School/Teachers/"));
const MissionsList = React.lazy(() => import("./School/Missions/"));
const SharedLessons = React.lazy(() => import("./School/SharedLessons/"));
const SharedFiles = React.lazy(() => import("./School/SharedFiles/"));
const StudentRanksList = React.lazy(() => import("./School/Ranks/"));
const SchoolStatistics = React.lazy(() => import("./School/Statistics/"));
const TeachersStatistics = React.lazy(() => import("./School/Teachers/Statistics.js"));
const SchoolCompetition = React.lazy(() => import("./School/Competition/"));

const StudentBooksList = React.lazy(() => import("./School/Student/Books"));
const StudentLessonsList = React.lazy(() => import("./School/Student/Lessons"));
const StudentFilesList = React.lazy(() => import("./School/Student/Files"));
const StudentExamsList = React.lazy(() => import("./School/Student/Exams"));
const StudentQuizzesList = React.lazy(() => import("./School/Student/Quizzes"));
const StudentMissionsList = React.lazy(() => import("./School/Student/Missions"));
const StudentDashBoard = React.lazy(() => import("./School/Student/DashBoard"));
const StudentGames = React.lazy(() => import("./School/Student/Games"));
const StudentCompetitionProfile = React.lazy(() => import("./School/Student/CompetitionProfile"));

const checkRolePermission = (role, userObj) => {
    if (!userObj || !userObj.UserType) return false;
    const userTypeId = userObj.UserType.Id;
    const schoolId = userObj.School?.Id;

    switch (role) {
        case 'admin':
        case 'manager':
            return userTypeId === 1;
        case 'onlineUser':
            return userTypeId === 1 || (userTypeId === 3 && schoolId !== 1);
        case 'user':
            return userTypeId === 2;
        case 'schoolAdmin':
            return userTypeId === 3 && schoolId !== 1;
        case 'teacher':
            return (userTypeId === 3 || userTypeId === 4) && schoolId !== 1;
        case 'student':
            return userTypeId === 5;
        default:
            return true;
    }
};

const Layout = ({ socket }) => {
    const dispatch = useDispatch();
    const user = useSelector(state => state.user);
    const location = useSelector(state => state.location);

    useEffect(() => {
        dispatch(checkLogin());

        // Asynchronous non-blocking version check
        const version = localStorage.getItem('version');
        api.get(`/Register/?id=` + (version || "")).then(response => {
            if (response.data && response.data.version) {
                if (version && version !== response.data.version) {
                    localStorage.setItem('version', response.data.version);
                    window.location.reload(true);
                } else if (!version) {
                    localStorage.setItem('version', response.data.version);
                }
            }
        }).catch(err => {
            console.error("Version check failed:", err);
        });

        // Initialize global live student observer
        studentLiveObserver.init();

        // Initialize AOS animations
        if (window.AOS) {
            window.AOS.init();
        }
    }, [dispatch]);


    useEffect(() => {
        let lastReportedTitle = "";
        let lastReportedLocation = "";

        const isLoadingOrGenericTitle = (title) => {
            if (!title) return true;
            const lower = title.toLowerCase().trim();
            return (
                lower.includes("التحميل جارٍ") ||
                lower.includes("انتظر") ||
                lower.includes("loading") ||
                lower === "هيّا إلى العربيّة" ||
                lower === "alarabeyya" ||
                lower === ""
            );
        };

        const resolveFriendlyRouteTitle = (pathname) => {
            const p = (pathname || "").toLowerCase();
            if (p.includes("/lessonview/")) return "مطالعة درس";
            if (p.includes("/examview/")) return "تدريب / اختبار";
            if (p.includes("/missionview/")) return "مهمة تعليمية";
            if (p.includes("/lessons")) return "الدروس التعليمية";
            if (p.includes("/missions")) return "المهام والواجبات";
            if (p.includes("/controlpanel/bills")) return "الفواتير والاشتراكات";
            if (p.includes("/controlpanel/users")) return "إدارة المستخدمين";
            if (p.includes("/controlpanel/onlineuser")) return "المستخدمين المتصلين";
            if (p.includes("/controlpanel/serverhealth")) return "مؤشرات أداء وصحة السيرفر";
            if (p.includes("/controlpanel") || p.includes("/user/control")) return "لوحة التحكم";
            if (p.includes("/profile")) return "الملف الشخصي";
            if (p.includes("/game")) return "الألعاب التفاعلية";
            if (p.includes("/stories") || p.includes("/story")) return "القصص والمكتبة";
            if (p === "/" || p === "") return "الصفحة الرئيسية";
            return pathname;
        };

        const trackCurrentPage = () => {
            if (user && user.isLogin && user.user) {
                const actualUser = user.user.user || user.user;
                const userId = actualUser.Id || actualUser.id;
                if (userId) {
                    realtimeService.registerUser(actualUser).catch(() => {});

                    const rawDocTitle = document.title ? document.title.split('|')[0].trim() : "";
                    const pageLocation = window.location.pathname + window.location.search;
                    const pageTitle = !isLoadingOrGenericTitle(rawDocTitle)
                        ? rawDocTitle
                        : resolveFriendlyRouteTitle(window.location.pathname);

                    if (pageTitle !== lastReportedTitle || pageLocation !== lastReportedLocation) {
                        lastReportedTitle = pageTitle;
                        lastReportedLocation = pageLocation;
                        realtimeService.setPageTitle(userId, pageTitle, pageLocation);
                    }
                }
            }
        };

        // Track page title on mount and with staggered timeouts to catch late Helmet updates
        trackCurrentPage();
        const t1 = setTimeout(trackCurrentPage, 400);
        const t2 = setTimeout(trackCurrentPage, 1200);
        const t3 = setTimeout(trackCurrentPage, 2500);

        // MutationObserver to catch Helmet dynamic title updates as soon as they render
        let titleObserver = null;
        try {
            const titleEl = document.querySelector('title');
            if (titleEl) {
                titleObserver = new MutationObserver(() => {
                    trackCurrentPage();
                });
                titleObserver.observe(titleEl, { childList: true, characterData: true, subtree: true });
            }
        } catch (err) {
            // ignore observer init errors
        }

        const unlistenHistory = history.listen(() => {
            setTimeout(() => {
                if (window.AOS) {
                    window.AOS.init();
                }
            }, 500);
            trackCurrentPage();
            setTimeout(trackCurrentPage, 600);
            setTimeout(trackCurrentPage, 1500);
        });

        return () => {
            clearTimeout(t1);
            clearTimeout(t2);
            clearTimeout(t3);
            if (titleObserver) {
                titleObserver.disconnect();
            }
            if (unlistenHistory) {
                unlistenHistory();
            }
        };
    }, [user]);

    const renderGuardedComponent = useCallback((SComponent, props, role) => {
        const isLogin = user && user.isLogin === true;
        const userObj = user && user.user;

        if (role === 'public') {
            if (isLogin) {
                return <Profile {...props} socket={socket} />;
            }
            return <SComponent {...props} socket={socket} />;
        }

        if (!role) {
            return <SComponent {...props} socket={socket} />;
        }

        if (!user || user.length === 0 || !isLogin) {
            return <Login {...props} socket={socket} />;
        }

        if (role === 'allUser') {
            if (SComponent !== ActivePage && SComponent !== Logout && userObj && userObj.IsActive === false) {
                return <ActivePage {...props} socket={socket} />;
            }
        }

        if (SComponent === ActivePage && userObj && userObj.IsActive === true && userObj.code !== "browser_is_not_recognized") {
            return <Profile {...props} socket={socket} />;
        }

        if (SComponent !== RecognizedBrowser && userObj && userObj.code === "browser_is_not_recognized") {
            return <RecognizedBrowser {...props} socket={socket} />;
        }

        if (SComponent === RecognizedBrowser && userObj && userObj.code !== "browser_is_not_recognized") {
            return <Profile {...props} socket={socket} />;
        }

        if (role !== 'allUser') {
            if (!checkRolePermission(role, userObj)) {
                return <Profile {...props} socket={socket} />;
            }
        }

        return <SComponent {...props} socket={socket} />;
    }, [user, socket]);

    const isILorPS = useMemo(() => (
        location?.location?.country_code === "il" ||
        location?.location?.country_code === "ps" ||
        user?.user?.Country === "il" ||
        user?.user?.Country === "ps"
    ), [location?.location?.country_code, user?.user?.Country]);

    return (
        <>
            <GlobalRealtimeAlerts />
            <header>
                <HeaderTop isLogin={user?.isLogin} user={user?.user}></HeaderTop>
                <HeaderBottom />
            </header>
            <div id="PageTop">
                <React.Suspense fallback={<Loading />}>
                    <Switch>

                        <Route exact path="/Tracks" component={Tracks} />
                        <Route exact path="/Tracks/Books" component={Books} />
                        <Route exact path="/Tracks/Books/:indexId" component={Books} />
                        <Route exact path="/Tracks/Lessons" component={Lessons} />
                        <Route exact path="/Tracks/Lessons/:indexId" component={Lessons} />
                        <Route exact path="/Tracks/BookLessons" component={BookLessons} />
                        <Route exact path="/Tracks/BookLessons/:indexId" component={BookLessons} />
                        <Route exact path="/Tracks/Files" component={Files} />
                        <Route exact path="/Tracks/Files/:indexId" component={Files} />
                        <Route exact path="/Tracks/Exams" component={Exams} />
                        <Route exact path="/Tracks/Exams/:indexId" component={Exams} />
                        <Route exact path="/Tracks/Quizzes" component={Quizzes} />
                        <Route exact path="/Tracks/Quizzes/:indexId" component={Quizzes} />

                        <Route exact path="/" component={Home} />
                        <Route exact path="/Home" component={Home} />
                        <Route exact path="/HomeSlider" component={HomeSlider} />
                        <Route exact path="/About" component={About} />
                        <Route exact path="/Slider/:id" component={Slider} />

                        <Route exact path="/Books/:id" component={Books} />
                        <Route exact path="/Books/:id/:indexId" component={Books} />
                        <Route exact path="/BookLessons/:id/:indexId" component={BookLessons} />
                        <Route exact path="/Lessons/:id" component={Lessons} />
                        <Route exact path="/Lessons/:id/:indexId" component={Lessons} />
                        <Route exact path="/Files/:id" component={Files} />
                        <Route exact path="/Files/:id/:indexId" component={Files} />
                        <Route exact path="/Exams/:id" component={Exams} />
                        <Route exact path="/Exams/:id/:indexId" component={Exams} />
                        <Route exact path="/Quizzes/:id" component={Quizzes} />
                        <Route exact path="/Quizzes/:id/:indexId" component={Quizzes} />

                        <Route exact path="/ExamView/:id" component={ExamView} />
                        <Route exact path="/SelfDevelopment/:id" component={SelfDevelopmentView} />
                        <Route exact path="/GameView/:id" component={GameView} />
                        <Route exact path="/LessonView/:id" component={LessonView} />
                        <Route exact path="/PDFView/:id" component={PDFView} />
                        <Route exact path="/FilePDFView/:id" component={FilePDFView} />
                        <Route exact path="/Logout" component={Logout} />
                        <Route exact path="/Chat" component={Chatbot} />
                        <Route exact path="/Search" component={Search} />
                        <Route exact path="/Search/:id" component={Search} />
                        <Route exact path="/PayproAfterPurchase/" component={PayproAfterPurchase} />
                        <Route exact path="/AfterPurchase/" component={AfterPurchase} />
                        <Route exact path="//AfterPurchase/" component={AfterPurchase} />
                        <Route exact path="/NoPermissions" component={NoPermissions} />
                        <Route exact path="/Contact" component={Contact} />
                        <Route exact path="/PayBill/" component={PayBill} />
                        <Route exact path="/Games/" component={Games} />
                        <Route exact path="/Games/:indexId" component={Games} />
                        <Route exact path="/CompetitionStage/" component={CompetitionStage} />
                        <Route exact path="/CompetitionInfo/" component={CompetitionInfo} />
                        <Route exact path="/ContactSupportConfirmation" component={ContactSupportConfirmation} />
                        <Route exact path="/User/UserGuide/" component={UserGuide} />
                        <Route exact path="/User/UserGuide/:id" component={UserGuide} />
                        <Route exact path="/User/UserGuides/Article/:id" component={Article} />

                        <Route exact path="/Registration" render={(props) => renderGuardedComponent(isILorPS ? Register : Registration, props, isILorPS ? 'public' : null)} />
                        <Route exact path="/Prices" render={(props) => renderGuardedComponent(isILorPS ? Register : Prices, props, isILorPS ? 'public' : null)} />
                        <Route exact path="/Register/Single" render={(props) => renderGuardedComponent(isILorPS ? Register : SingleRegister, props, 'public')} />

                        <Route exact path="/Register" render={(props) => renderGuardedComponent(Register, props, 'public')} />
                        <Route exact path="/Login" render={(props) => renderGuardedComponent(Login, props, 'public')} />
                        <Route exact path="/ForgetPassword" render={(props) => renderGuardedComponent(ForgetPassword, props, 'public')} />
                        <Route exact path="/ResetPassword/" render={(props) => renderGuardedComponent(ResetPassword, props, 'public')} />

                        {/* All Users */}
                        <Route exact path="/User/Mark" render={(props) => renderGuardedComponent(UserMarks, props, 'allUser')} />
                        <Route exact path="/User/History/Lessons" render={(props) => renderGuardedComponent(UserHistoryLessons, props, 'allUser')} />
                        <Route exact path="/User/History/Files" render={(props) => renderGuardedComponent(UserHistoryFiles, props, 'allUser')} />
                        <Route exact path="/User/Favorite/Files" render={(props) => renderGuardedComponent(UserFavoriteFile, props, 'allUser')} />
                        <Route exact path="/User/Favorite/Lesson" render={(props) => renderGuardedComponent(UserFavoriteLesson, props, 'allUser')} />
                        <Route exact path="/RecognizedBrowser" render={(props) => renderGuardedComponent(RecognizedBrowser, props, 'allUser')} />
                        <Route exact path="/ActivePage" render={(props) => renderGuardedComponent(ActivePage, props, 'allUser')} />
                        <Route exact path="/Profile" render={(props) => renderGuardedComponent(Profile, props, 'allUser')} />
                        <Route exact path="/Profile/Edit" render={(props) => renderGuardedComponent(ProfileEdit, props, 'allUser')} />
                        <Route exact path="/Profile/ChangePassword" render={(props) => renderGuardedComponent(ProfileChangePassword, props, 'allUser')} />
                        <Route exact path="/Profile/Picture" render={(props) => renderGuardedComponent(ChangeProfilePicture, props, 'allUser')} />
                        <Route exact path="/User/Control" render={(props) => renderGuardedComponent(UserControl, props, 'allUser')} />
                        <Route exact path="/User/Renwal" render={(props) => renderGuardedComponent(UserRenwal, props, 'allUser')} />
                        <Route exact path="/User/Subscription" render={(props) => renderGuardedComponent(UserSubscription, props, 'allUser')} />

                        <Route exact path="/MissionView/:id" render={(props) => renderGuardedComponent(MissionView, props, 'allUser')} />

                        {/* Manager / Admin edit */}
                        <Route exact path="/ControlPanel/Quizzes/Edit/:id" render={(props) => renderGuardedComponent(QuizzesEdit, props, 'manager')} />
                        <Route exact path="/ControlPanel/Exams/Edit/:id" render={(props) => renderGuardedComponent(ExamsEdit, props, 'manager')} />
                        <Route exact path="/ControlPanel/Books/Edit/:id" render={(props) => renderGuardedComponent(BookLessonEdit, props, 'manager')} />
                        <Route exact path="/ControlPanel/Lesson/Edit/:id" render={(props) => renderGuardedComponent(LessonEdit, props, 'manager')} />
                        <Route exact path="/ControlPanel/Games/Edit/:id" render={(props) => renderGuardedComponent(GamesEdit, props, 'manager')} />
                        <Route exact path="/ControlPanel/Indices" render={(props) => renderGuardedComponent(Indices, props, 'manager')} />
                        <Route exact path="/ControlPanel/Exams/:id" render={(props) => renderGuardedComponent(ExamsList, props, 'manager')} />
                        <Route exact path="/ControlPanel/Exams" render={(props) => renderGuardedComponent(ExamsList, props, 'manager')} />
                        <Route exact path="/ControlPanel/Quizzes/:id" render={(props) => renderGuardedComponent(QuizzesList, props, 'manager')} />
                        <Route exact path="/ControlPanel/Quizzes" render={(props) => renderGuardedComponent(QuizzesList, props, 'manager')} />
                        <Route exact path="/ControlPanel/Lessons/:id" render={(props) => renderGuardedComponent(LessonsList, props, 'manager')} />
                        <Route exact path="/ControlPanel/Lessons" render={(props) => renderGuardedComponent(LessonsList, props, 'manager')} />
                        <Route exact path="/ControlPanel/Files" render={(props) => renderGuardedComponent(FilesList, props, 'manager')} />
                        <Route exact path="/ControlPanel/Files/:id" render={(props) => renderGuardedComponent(FilesList, props, 'manager')} />
                        <Route exact path="/ControlPanel/Books" render={(props) => renderGuardedComponent(BooksList, props, 'manager')} />
                        <Route exact path="/ControlPanel/Books/:id" render={(props) => renderGuardedComponent(BooksList, props, 'manager')} />
                        <Route exact path="/ControlPanel/BookLessons/:id" render={(props) => renderGuardedComponent(BookLessonsList, props, 'manager')} />
                        <Route exact path="/ControlPanel" render={(props) => renderGuardedComponent(ControlPanel, props, 'manager')} />
                        <Route exact path="/ControlPanel/Games" render={(props) => renderGuardedComponent(FunList, props, 'manager')} />
                        <Route exact path="/ControlPanel/Games/:id" render={(props) => renderGuardedComponent(FunList, props, 'manager')} />
                        <Route exact path="/ControlPanel/SelfDevelopment/:id" render={(props) => renderGuardedComponent(SelfDevelopmentList, props, 'manager')} />
                        <Route exact path="/ControlPanel/SelfDevelopment" render={(props) => renderGuardedComponent(SelfDevelopmentList, props, 'manager')} />
                        <Route exact path="/ControlPanel/SelfDevelopment/Edit/:id" render={(props) => renderGuardedComponent(SelfDevelopmentEdit, props, 'manager')} />

                        {/* Admin */}
                        <Route exact path="/ControlPanel/Users" render={(props) => renderGuardedComponent(UsersList, props, 'admin')} />
                        <Route exact path="/ControlPanel/Schools" render={(props) => renderGuardedComponent(SchoolsList, props, 'admin')} />
                        <Route exact path="/ControlPanel/Schools/Registration" render={(props) => renderGuardedComponent(SchoolsRegistrationList, props, 'admin')} />
                        <Route exact path="/ControlPanel/MailBox" render={(props) => renderGuardedComponent(MailBoxList, props, 'admin')} />
                        <Route exact path="/ControlPanel/SearchResult" render={(props) => renderGuardedComponent(SearchResultList, props, 'admin')} />
                        <Route exact path="/ControlPanel/Sliders" render={(props) => renderGuardedComponent(SlidersList, props, 'admin')} />
                        <Route exact path="/ControlPanel/EmailContent" render={(props) => renderGuardedComponent(EmailContentList, props, 'admin')} />
                        <Route exact path="/ControlPanel/FileManager" render={(props) => renderGuardedComponent(FileManagerList, props, 'admin')} />
                        <Route exact path="/ControlPanel/Bills" render={(props) => renderGuardedComponent(BillsList, props, 'admin')} />
                        <Route exact path="/ControlPanel/SendEmail" render={(props) => renderGuardedComponent(SendEmail, props, 'admin')} />
                        <Route exact path="/ControlPanel/Templates" render={(props) => renderGuardedComponent(Templates, props, 'admin')} />
                        <Route exact path="/ControlPanel/Game/Templates" render={(props) => renderGuardedComponent(GameTemplates, props, 'admin')} />
                        <Route exact path="/ControlPanel/SchoolRank" render={(props) => renderGuardedComponent(SchoolRank, props, 'admin')} />
                        <Route exact path="/ControlPanel/StudentRank" render={(props) => renderGuardedComponent(StudentRank, props, 'admin')} />
                        <Route exact path="/ControlPanel/UserRank" render={(props) => renderGuardedComponent(UserRank, props, 'admin')} />
                        <Route exact path="/ControlPanel/Statistics" render={(props) => renderGuardedComponent(UsersStatistics, props, 'admin')} />
                        <Route exact path="/ControlPanel/OnlineUser" render={(props) => renderGuardedComponent(OnlineUser, props, 'onlineUser')} />
                        <Route exact path="/ControlPanel/WhatsApp/:phone?" render={(props) => renderGuardedComponent(WhatsApp, props, 'admin')} />
                        <Route exact path="/ControlPanel/SMS/:phone?" render={(props) => renderGuardedComponent(SMS, props, 'admin')} />
                        <Route exact path="/ControlPanel/ErrorReport" render={(props) => renderGuardedComponent(ErrorReport, props, 'admin')} />
                        <Route exact path="/ControlPanel/Competition/Statistics" render={(props) => renderGuardedComponent(CompetitionStatistics, props, 'admin')} />
                        <Route exact path="/ControlPanel/Statistics/Lessons" render={(props) => renderGuardedComponent(LessonsStatistics, props, 'admin')} />
                        <Route exact path="/ControlPanel/DeepSeek/:id?" render={(props) => renderGuardedComponent(DeepSeekAdmin, props, 'admin')} />
                        <Route exact path="/ControlPanel/QuestionsView" render={(props) => renderGuardedComponent(QuestionsAdminView, props, 'admin')} />
                        <Route exact path="/ControlPanel/CacheManager" render={(props) => renderGuardedComponent(CacheManagerAdmin, props, 'admin')} />
                        <Route exact path="/ControlPanel/ServerHealth" render={(props) => renderGuardedComponent(ServerHealthAdmin, props, 'admin')} />

                        {/* School Admin */}
                        <Route exact path="/ControlPanel/Teachers" render={(props) => renderGuardedComponent(TeachersList, props, 'schoolAdmin')} />

                        {/* School Teacher */}
                        <Route exact path="/ControlPanel/ClassRooms" render={(props) => renderGuardedComponent(ClassRoomsList, props, 'teacher')} />
                        <Route exact path="/ControlPanel/Missions" render={(props) => renderGuardedComponent(MissionsList, props, 'teacher')} />
                        <Route exact path="/ControlPanel/Shared/Lessons/" render={(props) => renderGuardedComponent(SharedLessons, props, 'teacher')} />
                        <Route exact path="/ControlPanel/Shared/Files/" render={(props) => renderGuardedComponent(SharedFiles, props, 'teacher')} />
                        <Route exact path="/ControlPanel/School/StudentRank" render={(props) => renderGuardedComponent(StudentRanksList, props, 'teacher')} />
                        <Route exact path="/ControlPanel/School/Statistics" render={(props) => renderGuardedComponent(SchoolStatistics, props, 'teacher')} />
                        <Route exact path="/ControlPanel/Teachers/Statistics" render={(props) => renderGuardedComponent(TeachersStatistics, props, 'teacher')} />
                        <Route exact path="/ControlPanel/School/Lessons/Statistics" render={(props) => renderGuardedComponent(LessonsStatistics, props, 'teacher')} />
                        <Route exact path="/Competition/Statistics" render={(props) => renderGuardedComponent(CompetitionStatistics, props, 'teacher')} />
                        <Route exact path="/School/Competition" render={(props) => renderGuardedComponent(SchoolCompetition, props, 'teacher')} />

                        {/* School Student */}
                        <Route exact path="/Student/Books" render={(props) => renderGuardedComponent(StudentBooksList, props, 'student')} />
                        <Route exact path="/Student/Lessons" render={(props) => renderGuardedComponent(StudentLessonsList, props, 'student')} />
                        <Route exact path="/Student/Files" render={(props) => renderGuardedComponent(StudentFilesList, props, 'student')} />
                        <Route exact path="/Student/Exams" render={(props) => renderGuardedComponent(StudentExamsList, props, 'student')} />
                        <Route exact path="/Student/Quizzes" render={(props) => renderGuardedComponent(StudentQuizzesList, props, 'student')} />
                        <Route exact path="/Student/Missions" render={(props) => renderGuardedComponent(StudentMissionsList, props, 'student')} />
                        <Route exact path="/Student/DashBoard/" render={(props) => renderGuardedComponent(StudentDashBoard, props, 'student')} />
                        <Route exact path="/Student/Games/" render={(props) => renderGuardedComponent(StudentGames, props, 'student')} />
                        <Route exact path="/Student/Game/Profile" render={(props) => renderGuardedComponent(StudentCompetitionProfile, props, 'student')} />
                        <Route exact path="/CompetitionView" render={(props) => renderGuardedComponent(CompetitionView, props, 'student')} />
                        <Route exact path="/Student/Competition" render={(props) => renderGuardedComponent(SchoolCompetition, props, 'student')} />

                        {/* Register Single User */}
                        <Route exact path="/User/SubUsers" render={(props) => renderGuardedComponent(SubUsers, props, 'user')} />
                        <Route exact path="/User/Bills" render={(props) => renderGuardedComponent(UserBills, props, 'user')} />

                        <Route component={NotFound} />
                    </Switch>
                </React.Suspense>
            </div>
        </>
    );
};

export default React.memo(Layout);
